var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "story-row" }, [
    _c(
      "div",
      {
        ref: "accentcontainer",
        staticClass: "bg-accent pt-40 pt-md-80 pt-xxl-120"
      },
      [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            {
              ref: "titlecontainer",
              staticClass:
                "d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-40 mb-md-80"
            },
            [
              _c("h2", { staticClass: "text-white mb-16 mb-lg-0" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c("a", { staticClass: "text-link", attrs: { href: _vm.href } }, [
                _vm._v(_vm._s(_vm.btn) + " "),
                _c("span", {
                  staticClass: "arrow-right",
                  domProps: {
                    innerHTML: _vm._s(_vm.svg("arrow-right", "arrow-right-svg"))
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "roundedcontainer",
              staticClass:
                "bg-container rounded pt-lg-40 pl-lg-40 pt-xl-80 pl-xl-80"
            },
            [
              _c(
                "div",
                {
                  ref: "floatingcontainer",
                  staticClass: "floating-container d-flex",
                  attrs: { "data-card-count": _vm.stories.length }
                },
                _vm._l(_vm.stories, function(story, index) {
                  return _c(
                    "div",
                    {
                      key: story.slug,
                      staticClass: "floating-category-card flex-shrink-0",
                      on: {
                        mouseenter: _vm.floatElement,
                        mouseleave: _vm.unfloatElement
                      }
                    },
                    [
                      _c("div", { staticClass: "zoom-wrapper" }, [
                        _c(
                          "a",
                          {
                            staticClass: "d-inline-block w-100 h-100",
                            attrs: {
                              href: _vm.route("nl.story", {
                                slug: story.post_name
                              })
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                ref: "imagecontainer" + index,
                                refInFor: true,
                                staticClass: "image-container h-100 d-flex"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: story.acf.image.sizes.large,
                                    alt: story.post_title
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content d-flex flex-column justify-content-end",
                                    style:
                                      "max-width: " + _vm.contentWidth + "px"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "subtitle mb-8 text-white font-weight-light"
                                      },
                                      [_vm._v(_vm._s(story.acf.author))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "title text-white font-weight-bold d-block"
                                      },
                                      [_vm._v(_vm._s(story.post_title))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "more small font-weight-light text-white mt-64"
                                      },
                                      [_vm._v("Lees meer")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }